import React, { useEffect, useState, useMemo, useContext } from "react";
import { TextField } from "@mui/material";
import { AuthContext } from "../../utils/userProvider";

import DataTable from "react-data-table-component";
import moment from "moment";

import useSearchAttempts from "../../queries/SearchAttempts/getSearchAttempts";
import Loader from "../../components/Loader";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
} from "../../components/ListPage";

const SearchAttempts = () => {
  const [searchAttemptsTable, setSearchAttemptsTable] = useState([]);
  const { authState, setAuthState } = useContext(AuthContext);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let columns = [
    {
      name: "First Name",
      selector: "first_name",
      sortable: false,
    },
    {
      name: "Last Name",
      selector: "last_name",
      sortable: false,
    },
    {
      name: "Email",
      selector: "email",
      sortable: false,
    },
    {
      name: "Agent",
      selector: (row) => (row.agent ? row.agent.agency_name : ""),
      sortable: true,
    },
    {
      name: "Property",
      selector: (row) => (row.property ? row.property.name : ""),
      sortable: true,
    },
    {
      name: "Pref",
      selector: "pref",
      sortable: false,
    },
    {
      name: "Tags",
      selector: "tags",
      sortable: false,
    },
    {
      name: "Start",
      selector: "startDate",
      sortable: true,
      cell: (row, index, column, id) => {
        return (
          <span>{moment(row.startDate).format("DD MMM YYYY hh:mm:ss A")}</span>
        );
      },
    },
    {
      name: "End",
      selector: "endDate",
      sortable: true,
      cell: (row, index, column, id) => {
        return (
          <span>{moment(row.endDate).format("DD MMM YYYY hh:mm:ss A")}</span>
        );
      },
    },
    {
      name: "Created At",
      selector: "createdAt",
      sortable: true,
      cell: (row, index, column, id) => {
        return (
          <span>{moment(row.createdAt).format("DD MMM YYYY hh:mm:ss A")}</span>
        );
      },
    },
  ];

  const [response, reset] = useSearchAttempts();

  const [filterText, setFilterText] = useState("");

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = searchAttemptsTable.filter((item) => {
    if (!filterText) return true;
    const q = filterText.toLowerCase();
    return (
      (item.property?.name &&
        item.property.name.toString().toLowerCase().includes(q)) ||
      (item.agent?.agency_name &&
        item.agent.agency_name.toString().toLowerCase().includes(q)) ||
      (item.pref && item.pref.toString().toLowerCase().includes(q)) ||
      (item.tags && item.tags.toString().toLowerCase().includes(q)) ||
      (item.email && item.email.toString().toLowerCase().includes(q)) ||
      (item.first_name &&
        item.first_name.toString().toLowerCase().includes(q)) ||
      (item.last_name && item.last_name.toString().toLowerCase().includes(q))
    );
  });

  useEffect(() => {
    if (response.data) {
      setSearchAttemptsTable([...response.data]);
    }
  }, [response]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div>
        <TextField
          id="filter-text"
          onChange={handleFilterText}
          label="Search"
          variant="outlined"
          size="small"
        />
      </div>
    );
  }, [filterText]);

  return (
    <ListPageShell>
      <ListPageCard>
        {response.loading && <Loader />}
        {!response.loading && (
          <div>
            <ListPageHeader title="Search Attempts" />
            <DataTable
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 30]}
              noHeader={true}
              subHeader
              data={filteredItems}
              columns={columns}
              subHeaderComponent={subHeaderComponentMemo}
              defaultSortField="createdAt"
              defaultSortAsc={false}
              customStyles={dataTableCustomStyles}
            />
          </div>
        )}
      </ListPageCard>
    </ListPageShell>
  );
};

export default SearchAttempts;
